
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 .687C16.692.687 21.312 5.308 21.312 11S16.692 21.312 11 21.312C5.308 21.312.687 16.692.687 11 .687 5.308 5.308.687 11 .687zm-1.277 9.429h-1.08a1.081 1.081 0 010-2.161h1.08c1.193 0 2.161.967 2.161 2.161v5.403c0 .597.484 1.08 1.08 1.08h1.081a1.081 1.081 0 010 2.162h-1.08a3.242 3.242 0 01-3.242-3.242v-5.403zm.54-7.565a1.621 1.621 0 110 3.242 1.621 1.621 0 010-3.242z"}})])
          )
        }
      }
    